import AadharDetail from "../../components/Forms/AadharDetail";
import PanForm from "../../components/Forms/PanForm";
import SingleGSTDetails from "../../components/Forms/SingleGSTDetails";
import UdyamDetails from "../../components/Forms/UdyamDetails";
import BankDetails from "../../containers/BankDetails";
import BankStatement from "../../containers/BankStatement";
import CompleteKYC from "../../containers/CompleteKYC";
import ContactUs from "../../containers/ContactUs";
import ContainerWithLogo from "../../containers/ContainerWithLogo";
import CustomerSuccess from "../../containers/CustomerSuccess";
import DocumentProof from "../../containers/DocumentProof";
import EligibleAmount from "../../containers/EligibleAmount";
import Enach from "../../containers/Enach";
import ErrorMessage from "../../containers/ErrorMessage";
import GSTreturn from "../../containers/GSTreturn";
import GstNumber from "../../containers/GstNumber";
import IncomeProof from "../../containers/IncomeProof";
import Loading from "../../containers/Loading";
import LoginP from "../../containers/Login";
import LoginPay from "../../containers/LoginPay";
import Login_new from "../../containers/Login__new";
import Login_new2 from "../../containers/Login__new2";
import Login_new3 from "../../containers/Login__new3";
import NewApprovedLimit from "../../containers/NewApprovedLimit";
import NotFound from "../../containers/NotFound";
import OTP from "../../containers/OTP";
import OTPPay from "../../containers/OTPPay";
import OrganisationDetails from "../../containers/OrganisationDetails";
import PFPayment from "../../containers/PFPayment";
import PFPaymentSuccess from "../../containers/PFPaymentSuccess";
import PaymentSuccess from "../../containers/PaymentSuccess";
import PendingENACH from "../../containers/PendingENACH";
import PendingKYC from "../../containers/PendingKYC";
import PropertyDetails from "../../containers/PropertyDetails";
import RedirectionURL from "../../containers/RedirectionURL";
import SignUp from "../../containers/SignUp";
import TermsAndConditions from "../../containers/TermsAndConditions";
import UdyogAadhaar from "../../containers/UdyogAadhaar";
import UploadGST from "../../containers/UploadGST";
import UploadIncomeTax from "../../containers/UploadIncomeTax";
import UploadOtherDocument from "../../containers/UploadOtherDocument";
import UploadShopCertificate from "../../containers/UploadShopCertificate";
import UploadTradeLicense from "../../containers/UploadTradeLicense";
import UploadUdhyam from "../../containers/UploadUdhyam";

const routesArray = [
  {
    key: 0,
    path: "/:Source/:Anchor/:Program",
    exact: false,
    element: LoginP,
    // element: Login_new2,
    // element: ContainerWithLogo,
    // element: Login_new3,
  },
  {
    key: 1,
    path: "/Pay/:Source/:Anchor/:Program",
    exact: false,
    element: LoginPay,
  },
  {
    key: 2,
    path: "*",
    exact: false,
    element: NotFound,
  },
  {
    key: 3,
    path: "/otp_p",
    exact: false,
    element: OTP,
    props: { source: "p" },
  },
  {
    key: 4,
    path: "/otp_f",
    exact: false,
    element: OTP,
    props: { source: "f" },
  },
  {
    key: 5,
    path: "/otp_l",
    exact: false,
    element: OTP,
    props: { source: "l" },
  },
  {
    key: 6,
    path: "/payotp_p",
    exact: false,
    element: OTPPay,
    props: { source: "p" },
  },
  {
    key: 7,
    path: "/payotp_f",
    exact: false,
    element: OTPPay,
    props: { source: "f" },
  },
  {
    key: 8,
    path: "/payotp_l",
    exact: false,
    element: OTPPay,
    props: { source: "l" },
  },
  {
    key: 12,
    path: "/signup",
    exact: false,
    element: SignUp,
  },
  {
    key: 13,
    path: "/pan",
    exact: false,
    element: PanForm,
  },
  {
    key: 15,
    path: "/repaymentLMS",
    exact: false,
    element: CustomerSuccess,
  },
  {
    key: 17,
    path: "/pfpayment",
    exact: false,
    element: PFPayment,
  },
  {
    key: 18,
    path: "/PaymentSuccess",
    exact: false,
    element: PaymentSuccess,
  },
  {
    key: 19,
    path: "/PFPaymentSuccess",
    exact: false,
    element: PFPaymentSuccess,
  },
  {
    key: 20,
    path: "/OrgDetails",
    exact: false,
    element: OrganisationDetails,
  },
  {
    key: 21,
    path: "/BankDetails",
    exact: false,
    element: BankDetails,
  },
  {
    key: 24,
    path: "/gst-number",
    exact: false,
    element: GstNumber,
  },
  {
    key: 25,
    path: "/error",
    exact: false,
    element: ErrorMessage,
  },
  {
    key: 26,
    path: "/upload-gst",
    exact: false,
    element: UploadGST,
  },
  {
    key: 28,
    path: "/udhyam-registration",
    exact: false,
    element: UdyogAadhaar,
  },
  {
    key: 29,
    path: "/upload-proof",
    exact: false,
    element: DocumentProof,
  },
  {
    key: 30,
    path: "/property-details",
    exact: false,
    element: PropertyDetails,
  },
  {
    key: 31,
    path: "/upload-income-proof",
    exact: false,
    element: IncomeProof,
  },
  {
    key: 32,
    path: "/loading",
    exact: false,
    element: Loading,
  },
  {
    key: 33,
    path: "/eligible-amount",
    exact: false,
    element: EligibleAmount,
  },
  {
    key: 34,
    path: "/complete-kyc",
    exact: false,
    element: CompleteKYC,
  },
  {
    key: 35,
    path: "/pending-kyc",
    exact: false,
    element: PendingKYC,
  },
  {
    key: 36,
    path: "/pending-enach",
    exact: false,
    element: PendingENACH,
  },
  {
    key: 37,
    path: "/terms-and-conditions",
    exact: false,
    element: TermsAndConditions,
  },
  {
    key: 38,
    path: "/enach",
    exact: false,
    element: Enach,
  },
  {
    key: 42,
    path: "/new-approved-limit",
    exact: false,
    element: NewApprovedLimit,
  },
  {
    key: 43,
    path: "/upload-udhyam",
    exact: false,
    element: UploadUdhyam,
  },
  {
    key: 44,
    path: "/upload-shop-certificate",
    exact: false,
    element: UploadShopCertificate,
  },
  {
    key: 45,
    path: "/upload-other-documents",
    exact: false,
    element: UploadOtherDocument,
  },
  {
    key: 46,
    path: "/upload-income-tax",
    exact: false,
    element: UploadIncomeTax,
  },
  {
    key: 47,
    path: "/upload-gst-return",
    exact: false,
    element: GSTreturn,
  },
  {
    key: 48,
    path: "/upload-bank-statement",
    exact: false,
    element: BankStatement,
  },
  {
    key: 51,
    path: "/upload-trade-license",
    exact: false,
    element: UploadTradeLicense,
  },

  {
    key: 52,
    path: "/contactUs",
    exact: false,
    element: ContactUs,
  },
  {
    key: 53,
    path: "/RedirectionURL",
    exact: false,
    element: RedirectionURL,
  },
  {
    key: 54,
    path: "/gst-number/gst_Detail",
    exact: false,
    element: SingleGSTDetails,
  },
  {
    key: 55,
    path: "/pan/Aadhar_Detail",
    exact: false,
    element: AadharDetail,
  },
  {
    key: 56,
    path: "/udhyam-registration/Udyam_Detail",
    exact: false,
    element: UdyamDetails,
  },
  {
    key: 57,
    path: "/:Source/:Anchor/:Program/:SalesLogin",
    exact: false,
    element: LoginP,
  },
];

export const routes = [...routesArray];
